import { render, staticRenderFns } from "./IcoHourglass.vue?vue&type=template&id=43d4d65e"
import script from "./IcoHourglass.vue?vue&type=script&lang=js"
export * from "./IcoHourglass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports